<template>
  <div class="campaign">
    <div class="campaign__header">
      <div class="campaign__header__back">
        <i class="adx-ic_arrow_left"></i>
        <span class="text" @click.stop="goToListCampaign">Campaigns</span>
      </div>
      <div class="campaign__header__title">
        <h2 class="medium-title">Add New Campaign</h2>
      </div>
    </div>
    <div class="campaign__main">
      <div class="campaign__main__left">
        <div class="campaign__main__left__campaign_selection">
          <adx-input
            label="Campaign Name"
            :value.sync="model.titleinput"
            :validation="['NewNotEmpty', 'NewMaxLength:190', 'NewMinLength:3', 'Alphanumeric']"
            :ref="dataRef.titleinput"
            :error.sync="errors.titleinput" />
        </div>
        <div v-for="(listing, index) in model.listings" :key="index" class="campaign__main__left__location_placement">
          <h1>Locations</h1>
          <div class="campaign__main__left__location_placement__row">
            <div class="campaign__main__left__location_placement__row__wrapper">
              <adx-input
              :class="[ listing.locationInput == null ? 'warning' :'']"
              :label="`Location`" :value.sync="listing.locationInput"
              :validation="['NewNotEmpty', 'NewMinLength:3', 'NewMaxLength:200', 'Alphanumeric']"
              :ref="dataRef.locationInput" :error.sync="errors.locationInput[index]"
              :inputId="`location_${index}`"/>
              <div class="icon-wrapper"><i @click="deleteListing(model.listings, index)" class="icon-deleted"></i></div>
            </div>
            <div v-if="listing.latitude && listing.longitude"  class="campaign__main__left__location_placement__row__bottom">Coordinate have been set <span @click="openModalCoordinate(index)" class="change">Change</span></div>
            <div v-else class="campaign__main__left__location_placement__row__coordinate-btn"><span class="text" @click.stop="openModalCoordinate(index)">Set Coordinate</span></div>
            <h1>Placement Per Location ({{countPlacement(listing.placements)}})</h1>
            <div v-for="(placement, index) in listing.placements" :key="index" class="campaign__main__left__location_placement__row__wrapper">
              <adx-input
                :class="[ listing.placementInput == null ? 'warning' :'']"
                :label="`Placement`" :value.sync="placement.placementInput"
                :validation="['NewNotEmpty', 'NewMinLength:3', 'NewMaxLength:190', 'Alphanumeric']"
                :ref="dataRef.placementInput" :error.sync="errors.placementInput[index]"
                :inputId="`placement_${index}`"/>
              <div class="icon-wrapper"><i @click="deletePlacement(listing, index)" class="icon-deleted"></i></div>
            </div>
            <div class="line-wrapper">
              <hr class="line">
            </div>
            <div class="campaign__main__left__location_placement__row__more-placement">
              <span class="text" @click.stop="addPlacement(listing)">Add More Placement</span>
            </div>
          </div>
        </div>
        <button type="button" class="secondary btn-block" @click.stop="addListing(model.listings)">Add More</button>
      </div>
      <div class="campaign__main__right">
        <div class="campaign__main__right__date">
          <adx-single-search-dropdown :label="`Owner`" class="dropdown" :value.sync="model.owner" :optionsParam="userOptions"/>
        </div>
        <div class="campaign__main__right__date">
          <div :class="['calendar', startDate == null && !startDateIsValid ? 'warning' : '']">
            <label class="small-font">Start Date</label>
            <v-date-picker
              v-model='startDate'
              :min-date='new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="startDate"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div :class="['calendar', endDate == null && !endDateIsValid ? 'warning' : '']">
            <label class="small-font">End Date</label>
            <v-date-picker
              v-model='endDate'
              :min-date='startDate ? startDate : new Date()'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                ref="endDate"
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
        </div>
        <button type="button" class="primary btn-block save" @click.stop="saveCampaign" :disabled='isLoading'>
          <span>Save Campaign</span>
          <loading-secondary v-if="isLoading"/>
        </button>
      </div>
    </div>
    <adx-modal
      v-if="showModalCoordinate"
      type="small"
      title="Set Coordinate"
      :hideClose="true">
      <div slot="content" class="campaign__modal">
        <div class="campaign__modal__search_map">
          <i class="adx-ic_search"></i>
          <gmap-autocomplete
            @place_changed="setPlace">
          </gmap-autocomplete>
        </div>
        <GmapMap
          :center="center"
          :zoom="15"
          map-type-id="terrain"
          style="width: 100%; height: 200px"
          ref="mapRef"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false }">
          <GmapMarker
            :position="center"
            :clickable="false"
            :draggable="false"/>
        </GmapMap>
        <div class="campaign__modal__place_data">
          <span>Country <strong>{{currentPlace ? currentPlace.country.long_name : 'Indonesia'}}</strong></span>
          <span>Province <strong>{{currentPlace ? currentPlace.province.long_name : 'DKI Jakarta'}}</strong></span>
          <span>City <strong>{{currentPlace ? currentPlace.city.long_name : 'Jakarta Selatan'}}</strong></span>
          <span>Area <strong>{{currentPlace ? currentPlace.area.long_name : 'Kuningan'}}</strong></span>
          <span>Address <strong>{{currentPlace ? currentPlace.address : ''}}</strong></span>
        </div>
        <div class="campaign__modal__buttons">
          <div class="campaign__modal__buttons__cancel">
            <button type="button" class="secondary btn-block" @click.stop="closeModalCoordinate">Cancel</button>
          </div>
          <div class="campaign__modal__buttons__save">
            <button type="button" class="primary btn-block" @click.stop="saveCoordinate" :disabled="!currentPlace">Save</button>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import moment from 'moment'
import calendar from 'v-calendar'
import Input from '@/components/Form/Input'
import Modal from '@/components/Modal'
import triggerValidation from "@/lib/triggerValidation"
import LoadingSecondary from '@/components/Loading/Secondary'
import SingleSearchDropdown from '@/components/Dropdown/SingleSearchDropdown'

import * as validationLib from '@/lib/validation/'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { gmapApi } from 'vue2-google-maps'
import { async } from 'q';

const {
  helpers
} = validationLib

export default {
  name: 'adx-monitoring-new-campaign',
  components: {
    'adx-input': Input,
    'adx-modal': Modal,
    'loading-secondary': LoadingSecondary,
    'adx-single-search-dropdown': SingleSearchDropdown,
  },
  props: {

  },
  data() {
    return {
      listCampaign: [
        {
          id: 1,
          label: 'BliBli Jakarta Run 2019',
          value: 1
        },
        {
          id: 2,
          label: 'BliBli Jakarta Run 2019',
          value: 2
        },
        {
          id: 3,
          label: 'BliBli Jakarta Run 2019',
          value: 3
        }
      ],
      totalRow: 1,
      isCoordinatSet: false,
      isLoading: false,
      isShowModalCoordinate: false,
      indexModal: null,
      model: {
        titleinput: null,
        listings: [
          {
            placements: [
              {
                placementInput: null
              }
            ],
            locationInput: null,
            latitude: '',
            longitude: '',
            city: '',
            area: ''
          }
        ],
        owner: null
      },
      userOptions:[],
      dataRef: {
        titleinput: 'titleinput',
        locationInput: 'locationInput',
        placementInput: 'placementInput',
      },
      errors: {
        titleinput: null,
        locationInput: [
          null
        ],
        placementInput: [
          null
        ],
      },
      inputDate: null,
      startDate: null,
      endDate: null,
      startDateIsValid: true,
      endDateIsValid: true,
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
      showModalCoordinate: false,
      center: {
        lat: -7.090910999999999, lng: 107.668887
      },
      currentPlace: null,
      locationIndex: null,
    }
  },
  computed: {
    google: gmapApi,
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    
  },
  mounted() {
    this.initialLoad()
    this.geolocate()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad(){
      (async () =>{
        const { data } = await api.get(apiV2.getUser, { needToken: true })
        data.results.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })
      })();
    },
    saveCampaign() {
      let isValid = triggerValidation(this.model, this.dataRef, this.$refs, this.errors)
      if (isValid) {
        if (!this.startDate) {
          this.startDateIsValid = false
          // console.log('NOT VALID START DATE')
          return
        }
        if (!this.endDate) {
          this.endDateIsValid = false
          // console.log('NOT VALID END DATE')
          return
        }
        const start = moment(this.startDate).format('YYYY-MM-DD')
        const end = moment(this.endDate).format('YYYY-MM-DD')
        let tempListing_set = []
        this.model.listings.map(x =>{
          x.placements.map(el => {
            tempListing_set.push({
              area: x.area,
              city: x.city,
              latitude: x.latitude,
              longitude: x.longitude,
              location_name: x.locationInput,
              start: start,
              end: end,
              placement: el.placementInput
            }) 
          })
        })
        const body = {
          title: this.model.titleinput,
          owner: this.model.owner,
          start: start,
          end: end,
          listing_set: tempListing_set
        }
        this.submit(body)
      } else {
      }
    },
    submit(body) {
      (async () => {
        this.isLoading = true
        const response = await api.post(apiV2.taskManagerCampaignListPage, body,{needToken: true})
        if (response.status == 200 || response.status == 201) {
          this.isLoading = false
          this.goToListCampaign()
        } else {
          this.isLoading = false
          if (response.status == 400) {
            const { error } = response.data
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: error,
              type: 'danger'
            });
          } else if (response.status == 404) {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Ticket Not Found',
              type: 'danger'
            });
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Sorry something went wrong! (Error code: ${response.status})`,
              type: 'warn'
            })
          }
        }
      })();
    },
    toggleModal(index = null){
      if (index !== null) {
        this.indexModal = index
      }
      this.isShowModalCoordinate = !this.isShowModalCoordinate
    },
    countPlacement(placements){
      return placements.length
    },
    addListing(listing) {
      listing.push(
        {
          locationInput: null,
          placements: [{
            placementInput: null
          }],
          latitude: '',
          longitude: '',
          city: '',
          area: ''
        }
      );
      this.errors.locationInput.push(
      null);
      this.errors.placementInput.push(
      null)
    },
    addPlacement(listing) {
      listing.placements.push(
        {
          placementInput: null,
        }
      );
    },
    deleteListing(listing, index) {
      if (listing.length > 1) {
        listing.splice(index, 1);
        this.errors.locationInput.splice(index,1);
        this.errors.placementInput.splice(index,1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    deletePlacement(listing, index){
      if (listing.placements.length > 1) {
        listing.placements.splice(index, 1);
        this.errors.placementInput.splice(index,1);
      } else {
        this.$notify({
          group: 'saved',
          title: 'Delete Error',
          text: 'Oops data can not be deleted!',
          type: 'danger'
        });
      }
    },
    goToListCampaign() {
      this.$router.push({ name: 'campaignmonitoring' })
    },
    searchLocation: function() {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({'address': 'Jakarta, Indonesia'}, (results, status) => {
        if (status === 'OK') {
          this.currentLocation.lat = results[0].geometry.location.lat();
          this.currentLocation.lng = results[0].geometry.location.lng();
        }
      });
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    getPlaceData(data, search) {
      const results = data.filter(x => x.types.includes(search))
      if (results.length > 0) {
        return results.pop()
      }
      return null
    },
    setPlace(place) {
      let lat = place.geometry.location.lat()
      let lng = place.geometry.location.lng()
      this.currentPlace = {
        lat: lat, lng: lng,
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3'),
      }
      this.center = this.currentPlace
    },
    dragPlace(place) {
      this.currentPlace = {
        lat: place.latLng.lat(),
        lng: place.latLng.lng(),
        address:  place.formatted_address,
        country:  this.getPlaceData(place.address_components, 'country'),
        province:  this.getPlaceData(place.address_components, 'administrative_area_level_1'),
        city:  this.getPlaceData(place.address_components, 'administrative_area_level_2'),
        area:  this.getPlaceData(place.address_components, 'administrative_area_level_3')
      }
      // var geocoder = new google.maps.Geocoder();
      // let latlng = new google.maps.LatLng(this.currentPlace.lat, this.currentPlace.lng)
      // geocoder.geocode({'latLng': latlng}, (results, status) => {
      //   debugger
      // })
      this.center = this.currentPlace
    },
    toggleModalCoordinate() {
      this.showModalCoordinate = !this.showModalCoordinate
    },
    openModalCoordinate(index) {
      this.locationIndex = index
      this.toggleModalCoordinate()
    },
    closeModalCoordinate() {
      this.currentPlace = null
      this.locationIndex = null
      this.toggleModalCoordinate()
    },
    saveCoordinate() {
      this.model.listings[this.locationIndex].latitude = this.currentPlace.lat
      this.model.listings[this.locationIndex].longitude = this.currentPlace.lng
      this.model.listings[this.locationIndex].city = this.currentPlace.city.long_name
      this.model.listings[this.locationIndex].area = this.currentPlace.area.long_name
      // this.model.listings[this.locationIndex].locationInput = this.currentPlace.address
      this.currentPlace = null
      this.locationIndex = null
      this.toggleModalCoordinate()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>